import React, { useState } from 'react'
import LeafletForm from '../leaflet-form/leaflet-form'
import wpIco from '../../../assets/images/whatsapp.png'
import FormCodeVerification from '../form-code-verification/form-code-verification'
import FormLoyalty from '../form-loyalty/form-loyalty'
import WebinarService from '../../../shared/services/webinar'
import { secureStorage } from "../../../shared/state/utils/utilities-secure-storage";
import errorIcon from '../../../shared/assets/images/icon-advertencia.svg';
import GenericModalAlert from '../../../shared/components/molecules/generic-modal-alert/generic-modal-alert'
import InputWebinar from '../../atoms/input-webinar/input-webinar';
import ButtonLoading from "../../../shared/components/molecules/buttonLoading/buttonLoading";
import './form-view.scss'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode'

const FormView = props => {
    const { textoObjetivoWebinar, identificadorWebinar, redireccionWhatsApp, webinarStatus, isPY, pyInfo, profesiones, redireccionWebinar, isWomenWebinar } = props;
    const [stepState, setstepState] = useState(
        webinarStatus === 'En el Evento' ?
            'stepInEvent'
            :
            webinarStatus === 'Después del Evento' ?
                'stepPostEvent'
                :
                'step1'
    )
    React.useEffect(() => {
        if (props.currentStep === "index") {
            setstepState("step1")
        }
        else if (props.currentStep === "ingresar/") {
            setstepState("stepInEvent")
        }
    }, [])
    const EMAIL_RX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    const { homeLink } = useHomeLinkMode();
    // const [stepState, setstepState] = useState('stepInEvent')

    const [userInfoPreload, setuserInfoPreload] = useState(null);
    const [isModalAlertVisible, setModalAlertVisibility] = useState(false)
    const [modalAlertText, setModalAlertText] = useState("")
    const [isLoaderVisible, setLoaderVisible] = React.useState(false);

    // const [userInfoPreload, setuserInfoPreload] = useState('hola')
    const [email, setemail] = useState('')

    //Errors
    const [emailError, setemailError] = useState(false)

    const retrygetCertificate = (_webinarId, _userId) => {
        let config = {
            responseType: 'blob'
        }
        WebinarService.getCertificate(_webinarId, _userId, config).then(resp => {
            if (resp.status === 200) {
                const file = new Blob([resp.data], { type: 'application/pdf' });
                const fileURL = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = fileURL;
                link.download = "Certificado.pdf";
                link.click();
            }
        })
            .catch(err => {
                let event = new CustomEvent("errorServiceModal", { "detail": 'Lo sentimos, tenemos un error generando el certificado, inténtalo de nuevo más tarde.' });
                document.dispatchEvent(event);
            })
    }

    const haveErrors = () => {
        if (!email) {
            setemailError('Debes llenar este campo')
        } else {
            if (!email.match(EMAIL_RX)) {
                setemailError('El correo no es válido')
            } else {
                setemailError(false)
            }
        }
        return (
            (!email ? true : (!email.match(EMAIL_RX)))
        )
    }

    const handleValidMail = () => {
        console.log("entro", isWomenWebinar)
        if (!haveErrors()) {
            setLoaderVisible(true);
            let payload = {
                event: identificadorWebinar,
                user: email
            }
            WebinarService.validateEmail(payload).then(resp => {
                if (resp.status === 200) {
                    if (resp.data.status === 400) {
                        setemailError(resp.data.userMessage)
                    }
                    else if (resp.data.status === 200) {
                        secureStorage.setItem("userWebinarIframe", resp.data.data);
                        window.location.href = homeLink + "webinar/ver-webinar/";
                    }
                }
                setLoaderVisible(false);
            })
                .catch(err => { console.log(err); setLoaderVisible(false); })
        }
    }

    const whatsappElement = (copy) => {

        return (
            <a className={isWomenWebinar ? "f-webinar-form-whatsapp f-webinar-form-whatsapp--women" : "f-webinar-form-whatsapp"} href={'https://wa.me/' + redireccionWhatsApp.slice(1, redireccionWhatsApp.length)} rel="noopener noreferrer" target="_blank">
                <div className="f-webinar-form-whatsapp-title">
                    {copy ? copy : '¿Necesitas ayuda?'}
                </div>
                <img
                    className="f-webinar-whatsapp-icon"
                    src={wpIco}
                    alt='Ícono whatsapp'
                />
            </a>
        )
    }

    const step1 = (
        <div className={isWomenWebinar ? "f-webinar-form-container f-webinar-form-container--women" : "f-webinar-form-container"}>
            <div className="f-webinar-form-header f-webinar-header-1">
                {isWomenWebinar ? null : <p>{textoObjetivoWebinar}</p>}
                <b>INSCRÍBETE YA GRATIS</b>
                <p>{isWomenWebinar ? "Para ver el WEBINAR." : "Para poder asistir a las conferencias."} </p>
            </div>
            <LeafletForm
                setstepState={setstepState}
                identificadorWebinar={identificadorWebinar}
                isPY={isPY}
                pyInfo={pyInfo}
                profesiones={profesiones}
                isWomenWebinar={isWomenWebinar}
            />
            {whatsappElement('¿Necesitas ayuda con tu registro?')}
        </div>
    )

    const step2 = (
        <div className={isWomenWebinar ? "f-webinar-form-container f-webinar-form-container--women" : "f-webinar-form-container"}>
            <div className="f-webinar-form-header f-webinar-header-2 full">
                <p className="f-webinar-header-title">¡Registro exitoso!</p>
                {/* <b>Gracias por tu participación.</b> */}
                {isWomenWebinar ?
                    <p>Pronto estaremos conversando sobre la sexualidad en la mujer madura en nuestro Webinar Latinoamericano. <br />
                    Te esperamos el próximo 8 de octubre aquí en nuestro sitio web. </p>
                    :
                    <p>Pronto estaremos compartiendo conocimiento especializado para el bienestar y cuidado del adulto mayor, te esperamos en nuestro Seminario Latinoamericano.</p>
                }
                <button className="f-succes-retry-button f-enter-space" onClick={() => setstepState('step1')}>
                    REALIZAR OTRO REGISTRO
                </button>
                <div  className="f-enter-webinar">
                    <a className="f-enter-webinar-btn" href={homeLink + 'webinar/ingresar/'}>Ingresa al Webinar</a>
                </div>
            </div>
            {whatsappElement('¿Necesitas ayuda con tu registro?')}
        </div>
    )

    const stepInEvent = (
        <div className={isWomenWebinar ? "f-webinar-form-container f-webinar-form-container--women" : "f-webinar-form-container"}>
            <div className="f-webinar-form-header f-webinar-header-inevent full">
                <p className="f-webinar-header-title">{isWomenWebinar ? "¡Ya inició nuestro Webinar Latinoamericano!" : "¡Pronto daremos inicio a nuestro webinar!"}</p>
                <p>{isWomenWebinar ? "Ingresa el correo electrónico con el que previamente realizaste tu registro y no te pierdas nuestro tema sobre la sexualidad en la mujer madura con Flavia Dos Santos." : "No te lo pierdas."}</p>
                <p>{isWomenWebinar ? "Si te registraste por Facebook, ingresa con el correo registrado en tu perfil" : null}</p>
                {
                    isWomenWebinar ? null :
                        <p>
                            Ya todos estamos conectados por el bienestar del Adulto Mayor.
                            <br />
                            <br />
                            <b>
                                4 PM: Colombia, Ecuador y Perú
                                <br />
                                5 PM: Bolivia, Puerto Rico, República Dominicana
                                <br />
                                6 PM: Argentina
                                <br />
                            </b>
                        </p>
                }

                {
                    isWomenWebinar ?
                        <InputWebinar
                            label='Email'
                            placeholder='ejemplo@mail.com'
                            error={emailError}
                            onChange={e => setemail(e.replace(/ /g, ''))}
                            value={email}
                            isWomenWebinar={true}
                        /> : null
                }
                <ButtonLoading
                    // isEnabled={!(formState.isValid && terms && !isEmailActive && !isCellPhoneActive)}
                    button={
                        <button className="f-succes-retry-button" onClick={() => { isWomenWebinar ? handleValidMail() : window.open(redireccionWebinar, '_blank') }}>
                            INGRESAR
                        </button>
                    }
                    isShowingLoader={isLoaderVisible}
                    bgClass="honey-flower"
                />
                <p>Si no te registraste, hazlo <a href={homeLink + "webinar/"} >aquí</a></p>
                {/* <button className="f-succes-retry-button" onClick={() => { isWomenWebinar ? handleValidMail() : window.open(redireccionWebinar, '_blank')}}>
                    INGRESAR
                </button> */}
            </div>
            {whatsappElement('¿Necesitas ayuda para ingresar?')}
        </div>
    )

    const stepPostEvent = (
        <div className="f-webinar-form-container">
            <div className="f-webinar-form-header f-webinar-header-postevent">
                <b className="f-webinar-header-title">¡Solicita tu certificado!</b>
                <p>Obtenlo de manera fácil después de cada conferencia. Solo deberás llenar los datos y lo recibirás vía e-mail. <br />  <br />  *Los datos que te solicitamos son necesarios para descargar tu diploma</p>
            </div>
            <FormCodeVerification
                isPY={isPY}
                pyInfo={pyInfo}
                setstepState={setstepState}
                setuserInfoPreload={setuserInfoPreload}
            />
            {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
        </div>
    )

    const stepLoyaltyForm = (
        <div className="f-webinar-form-container">
            <div className="f-webinar-form-header f-webinar-header-postevent">
                <b className="f-webinar-header-title">¡Solicita tu certificado!</b>
                <p>Obtenlo de manera fácil después de cada conferencia. Solo deberás llenar los datos y lo recibirás vía e-mail. <br /> <br />  *Los datos que te solicitamos son necesarios para descargar tu diploma</p>
            </div>
            <FormLoyalty
                profesiones={profesiones}
                isPY={isPY}
                pyInfo={pyInfo}
                userInfoPreload={userInfoPreload}
                setstepState={setstepState}
                webinarId={identificadorWebinar}
                setModalAlertVisibility={setModalAlertVisibility}
                setModalAlertText={setModalAlertText}
            />
            {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
        </div>
    )

    const stepSuccessLoyalty = (
        <div className="f-webinar-form-container">
            <div className="f-webinar-form-header f-webinar-header-2 full">
                <p className="f-webinar-header-title">¡Registro exitoso!</p>
                <b>¡Felicitaciones!</b>
                <p>
                    Tu diploma ha sido descargado, si no lo ves vuelvelo
                    <b className="f-retry-certificate-button" onClick={() => retrygetCertificate(identificadorWebinar, userInfoPreload.userId)}>a descargar aquí</b>
                </p>

                {/* <button className="f-succes-retry-button" onClick={() => setstepState('step1')}>
                    REALIZAR OTRO REGISTRO
                </button> */}
            </div>
            {whatsappElement('¿Necesitas ayuda para descargar el certificado?')}
        </div>
    )

    return (
        <>
            {stepState === 'step1' && step1}
            {stepState === 'step2' && step2}
            {stepState === 'stepInEvent' && stepInEvent}
            {stepState === 'stepPostEvent' && stepPostEvent}
            {stepState === 'stepLoyaltyForm' && userInfoPreload && stepLoyaltyForm}
            {stepState === 'stepSuccessLoyalty' && stepSuccessLoyalty}
            {isModalAlertVisible &&
                <GenericModalAlert
                    icon={errorIcon}
                    title="Lo sentimos"
                    description={modalAlertText}
                    handleAction={setModalAlertVisibility}
                    type="primary"
                />}
        </>
    )
}

export default FormView
